import { useEffect } from "react";

/** A conversa abre no fim, como qualquer app de mensagem. */
export function RolarParaOFim({ alvo, chave }: { alvo: string; chave: string }) {
  useEffect(() => {
    const el = document.getElementById(alvo);
    if (el) el.scrollTop = el.scrollHeight;
  }, [alvo, chave]);
  return null;
}
